var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"col-md-12 text-center"},[_c('span',{staticStyle:{"font-size":"24px"}},[_c('i',{class:'fas ' + _vm.icone})]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.mensagem))])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }